import React, { Suspense } from 'react';
import { Helmet } from 'react-helmet';
import { Stack, Box } from '@mui/material';
import Empty from 'components/empty';
import announcementStyle from 'pages/announcements/style';

const AnnouncementForm = React.lazy(() => import('pages/announcements/AnnouncementForm'));

const CreateAnnouncement = () => (
    <>
        <Helmet>
            <title>Create Announcement - DevX Infra</title>
        </Helmet>
        <Suspense
            fallback={
                <Stack sx={announcementStyle?.loadingStack}>
                    <Empty color="#000000" isLoading />
                </Stack>
            }
        >
            <Box className="contentContainer" sx={announcementStyle?.wrapper} data-testid="create-announcement-page">
                <AnnouncementForm />
            </Box>
        </Suspense>
    </>
);

export default CreateAnnouncement;
